export const statusSelected = [
  { id: "", name: "Selecione" },
  { id: "ACTIVE", name: "Ativo" },
  { id: "INACTIVE", name: "Inativo" }
];
